module.exports = __webpack_public_path__ + "img/3.a169ead3.svg";